import {useNeoContext} from "@/context/neo/neo.context";
import {driversService} from "@/service/drivers.service";
import {Tab, Tabs} from "@nextui-org/react";
import {useEffect, useRef, useState} from "react";
import {BasicInfoForm} from "./widgets/form/basicInfoForm";
import {ComplianceForm} from "./widgets/form/complianceForm";
import {LicenseForm} from "./widgets/form/licenseForm";
import {VehicleFormv2} from "./widgets/form/vehiceForm";
interface Driver {
  institutionId: number | null;
  userId: string | null;
  name: string;
  driverId: string;
  mobileNo: string;
  dateOfBirth: Date | null;
  licenceNo: string;
  licenceValidityDate: Date | null;
  driverPhoto: string;
}
export const DriverFormv2: React.FC<any> = function ({data, onClose}) {
  const [loading, setLoading] = useState(false);
  const {filterContext} = useNeoContext();
  const [selectedTab, setSelectedTab] = useState("personal");
  const currentRequestId = useRef<string | null>(null);
  const setDriverDefautval = () => {
    return {
      driver: {
        institutionId: filterContext.client.institutionId,
        userId: filterContext.client.institutionUserId,
        name: "",
        driverId: "",
        mobileNo: "",
        dateOfBirth: null,
        licenceNo: "",
        licenceValidityDate: null,
        driverPhoto: ""
      },
      vehicle: {},
      documents: {},
      compliance: {
        licenceNo: "",
        licenceValidityDate: null,
        badgeNo: "",
        badgeExpiryDate: null,
        medicalTestExpiryDate: null,
        pvcExpiryDate: null,
        ddtCertificateNo: "",
        ddtExpiryDate: null,
        bgv: false,
        bgvExpiryDate: null
      }
    };
  };
  const [driverEditdata, setDriverEditdata] = useState<{
    driver: Driver;
    vehicle: any;
    documents: any;
    compliance: any;
  }>(setDriverDefautval());

  const parseCustomDate = (dateStr: string): Date | null => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed
  };
  useEffect(() => {
    if (data.driverId) {
      fetchData(data.driverId);
    } else {
      currentRequestId.current = "";
      const defaultVal = setDriverDefautval();
      setDriverEditdata(defaultVal);
    }
  }, [data.driverId]);

  useEffect(() => {
    setSelectedTab(data.selectedTab || "personal");
  }, [data.selectedTab]);

  const handleNext = () => {
    if (selectedTab === "personal") setSelectedTab("compliance");
    else if (selectedTab === "compliance") setSelectedTab("vehicle");
    else if (selectedTab === "vehicle") setSelectedTab("documents");
  };
  const handleTabChange = (key: React.Key) => {
    setSelectedTab(String(key));
  };
  const fetchData = async (driverId: any) => {
    if (driverId) {
      currentRequestId.current = driverId;
      setLoading(true);
      await driversService
        .onGetSingleDriver(driverId as string)
        .then((response: any) => {
          if (
            response.status === "success" &&
            currentRequestId.current === driverId
          ) {
            //    name,mobileNo,dateOfBirth,licenceNo,licenceValidityDate
            const resData = response.data;
            setDriverEditdata({
              driver: {
                institutionId: filterContext.client.institutionId,
                userId: filterContext.client.institutionUserId,
                name: resData.name,
                driverId: resData.userId,
                mobileNo: resData.phoneNumber,
                dateOfBirth: resData.dob ? parseCustomDate(resData.dob) : null,
                licenceNo: resData.licenseNumber || "",
                licenceValidityDate: resData.licenseValidityDate
                  ? parseCustomDate(resData.licenseValidityDate)
                  : null,
                driverPhoto: resData.driverPhoto
              },
              vehicle: {
                trackerId: resData.trackerId,
                trackerName: resData.trackerName,
                driverId: resData.userId
              },
              documents: {
                name: resData.name,
                driverId: resData.userId,
                mobileNo: resData.phoneNumber,
                driverPhoto: resData.driverPhoto,
                institutionId: filterContext.client.institutionId,
                userId: filterContext.client.institutionUserId,
                licenseDocuments: resData.licenseDocuments,
                otherDocuments: resData.otherDocuments
              },
              compliance: {
                licenceNo: resData.licenseNumber || "",
                licenceValidityDate: resData.licenseValidityDate
                  ? parseCustomDate(resData.licenseValidityDate)
                  : null,
                badgeNo: resData.badgeNo || "",
                badgeExpiryDate: resData.badgeExpiryDate
                  ? parseCustomDate(resData.badgeExpiryDate)
                  : null,
                medicalTestExpiryDate: resData.medicalTestExpiryDate
                  ? parseCustomDate(resData.medicalTestExpiryDate)
                  : null,
                pvcExpiryDate: resData.pvcExpiryDate
                  ? parseCustomDate(resData.pvcExpiryDate)
                  : null,
                ddtCertificateNo: resData.ddtCertificateNo || "",
                ddtExpiryDate: resData.ddtExpiryDate
                  ? parseCustomDate(resData.ddtExpiryDate)
                  : null,
                bgv: resData.bgv || false,
                bgvExpiryDate: resData.bgvExpiryDate
                  ? parseCustomDate(resData.bgvExpiryDate)
                  : null
              }
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  return (
    <>
      <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-2">
        {/* <div className="mb-5 flex-row">
                  <NeoHeader message="Drivers"></NeoHeader>
                </div> */}
        <div className="flex w-full flex-col gap-2">
          <Tabs
            key={"lg"}
            aria-label="Disabled Options"
            radius={"full"}
            selectedKey={selectedTab}
            onSelectionChange={handleTabChange}
            disabledKeys={
              !driverEditdata.driver.driverId
                ? ["vehicle", "documents", "compliance"]
                : []
            }
            //driverEditdata.driver.driverId
          >
            <Tab key="personal" title="Personal Details">
              <BasicInfoForm
                driverEditdata={driverEditdata.driver}
                driverComplianceEditdata={driverEditdata.compliance}
                getDriverData={fetchData}
                onClose={onClose}
                handleNext={handleNext}
              />
            </Tab>
            <Tab key="compliance" title="Compliance">
              <ComplianceForm
                driverComplianceEditdata={driverEditdata.compliance}
                driverEditdata={driverEditdata.driver}
                handleNext={handleNext}
              />
            </Tab>
            <Tab key="vehicle" title="Vehicle Details">
              <VehicleFormv2
                driverVehicleEditdata={driverEditdata.vehicle}
                driverEditdata={driverEditdata.driver}
                getDriverData={fetchData}
                isShowDelete={true}
              />
            </Tab>
            <Tab key="documents" title="Documents">
              <LicenseForm
                documentsEditdata={driverEditdata.documents}
                onClose={onClose}
              />
            </Tab>
          </Tabs>
        </div>
        {/* <div className="flex w-full flex-row gap-4">
          <div className="w-[50%] flex-row">
            <BasicInfoForm driverEditdata={driverEditdata.driver} />
          </div>
          <div className="w-[50%] flex-row">
            <div className="flex w-full flex-col space-y-4 ">
              <VehicleFormv2 driverVehicleEditdata={driverEditdata.vehicle} />
              <LicenseForm />
               <OtherDocumentForm /> 
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};
